import { colors } from '@/theme/colors';

export interface SavingsBadgePillProps {
  totalSavingsPerYear: number;
}

export default function SavingsBadgePill({ totalSavingsPerYear }: SavingsBadgePillProps) {
  const pillText = `Save $${totalSavingsPerYear.toLocaleString()}+`;
  return (
    <div
      style={{
        // Need to define background gradient as a style since tailwind is unable to apply background linear
        // gradients when using string interpolation to set gradient colors
        background: `linear-gradient(289deg, ${colors.neutral100} 54.47%, ${colors.orange95} 100%)`,
      }}
      className="flex items-center justify-center rounded-[100px] border border-solid border-flexcar-neutral100 px-2 py-[0.5px]"
    >
      <p className="body2-strong overflow-hidden text-ellipsis whitespace-nowrap text-flexcar-neutral1">
        {pillText}
      </p>
    </div>
  );
}
